import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges, TemplateRef } from "@angular/core";
import { BsModalRef, BsModalService } from "ngx-bootstrap/modal";
import { Subscription } from "rxjs";
import { AuthService } from "src/app/core/service/auth.service";
import { RestClientService } from "src/app/core/service/rest-client.service";
import { UtilitiesService } from "src/app/core/service/utilities.service";
import Swal from "sweetalert2";
import * as moment from "moment";
import * as _ from "lodash";
import { DomSanitizer } from "@angular/platform-browser";


@Component({
  selector: 'app-scroll-search-beneficiaire',
  templateUrl: './scroll-search-beneficiaire.component.html',
  styleUrls: ['./scroll-search-beneficiaire.component.scss']
})
export class ScrollSearchBeneficiaireComponent implements OnInit {

  items: Array<any> = [];
  user: any = {};
  currentPage: number = 0;
  itemsPerPage: number = 10;
  busyGet: Subscription;
  searchKeyBeneficiaire: any = "";
  beneficiaire_id: any
  @Input() statut_id: any;
  @Input() current_beneficiaire_id: any;
  @Input() clearText: any;
  @Input() emmitFull: any;
  @Output() onSelectBeneficiaire = new EventEmitter();
  constructor(
    private authService: AuthService,
    private restClient: RestClientService,
  ) {
    // this.user = this.authService.currentUserValue;
    this.user = this.authService.getCurrentUser();

  }

  ngOnChanges(changes: SimpleChanges) {

    if (changes.statut_id && changes.statut_id.currentValue) {
      this.statut_id = changes.statut_id.currentValue;
    }

    if (changes.current_beneficiaire_id && changes.current_beneficiaire_id.currentValue) {
      this.beneficiaire_id = changes.current_beneficiaire_id.currentValue;
    }
    if (changes.clearText && changes.clearText.currentValue) {
      this.clearSelection()
    }
    this.itemsPerPage = 10
    this.getItems()
  }
  onSearch(event) {
    console.log("fkdkfjkd", event);
    this.itemsPerPage = 10;
    this.searchKeyBeneficiaire = event.term;
    if (event.term.length)
      this.getItems();
  }

  clearSelection() {
    this.beneficiaire_id = null; // or undefined
    this.items = []
    this.searchKeyBeneficiaire = ''
  }


  onGetMoreItems() {
    this.itemsPerPage += 5;
    this.getItems();
  }


  onSelectElement() {
    if(this.emmitFull){
      let full_benef = this.items.find((it:any)=>it.id==this.beneficiaire_id)
      this.onSelectBeneficiaire.emit(full_benef)
    }

    else{
      this.onSelectBeneficiaire.emit(this.beneficiaire_id)
      
    }

  }

  getItems() {
    let request = {
      user_id: this.user.id,
      filiale_id: this.user.filiale_id,
      index: 0,
      size: this.itemsPerPage,
      search_key: this.searchKeyBeneficiaire,
      data: {
        // reseau_de_soin_id: this.reseau_de_soin_id,
        statut_id: this.statut_id,
      },
    };

    this.busyGet = this.restClient
      .post("beneficiaire/getByCriteria", request)
      .subscribe(
        (res) => {
          if (res && res["items"]) {
            this.items = _.orderBy(
              res["items"],
              ["libelle"],
              ["asc"]
            );
          } else {
            this.items = [];
          }
        },
        (err) => {
          this.items = [];
        }
      );
  }



  onSelectTypePrestataire() { }

  ngOnInit() {
  }

}
